export enum SurveyStatus {
  Draft = 11,
  Live = 22,
  Paused = 33,
  Closed = 44,
  Invoice = 55,
}
